import Vue from "vue";
import NProgress from "nprogress";
import VueRouter from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { requiresGuest: true },
  },
  {
    path: "/about-us",
    name: "about",
    component: () => import("../views/AboutUs"),
  },
  {
    path: "/disclaimers",
    name: "disclaimers",
    component: () => import("../views/Disclaimers"),
  },
  {
    path: "/refunds",
    name: "refunds",
    component: () => import("../views/Refunds"),
  },
  {
    path: "/careers",
    name: "career",
    component: () => import("../views/Careers"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("../views/Terms"),
  },
  {
    path: "/subscriptions",
    name: "subscription",
    component: () => import("../views/Subscription"),
  },
  {
    path: "/privacy-policy",
    name: "policy",
    component: () => import("../views/PrivacyPolicy"),
  },
  {
    path: "/contact-us",
    name: "Contact",
    component: () => import("../views/ContactUs"),
  },
  {
    path: "/faqs",
    name: "faqs",
    component: () => import("../views/Faq"),
  },
  {
    path: "/notifications",
    name: "notifications",
    component: () => import("../views/Notification"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/Dashboard"),
    // meta: { requiresGuest: true },
  },
  {
    path: "/donate",
    name: "donate",
    component: () => import("../views/Donate"),
  },
  {
    path: "/accounts/verify",
    name: "verify-account",
    component: () => import("../views/accounts/VerifyAccount"),
  },
  {
    path: "/stripe-return",
    name: "stripe-return",
    component: () => import("../views/StripeReturn"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/stripe-refresh",
    name: "stripe-refresh",
    component: () => import("../views/StripeRefresh"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/booking-successful",
    name: "booking-successful",
    component: () => import("../views/BookingSuccess"),
    meta: { requiresAuth: true },
  },
  {
    path: "/booking-failed",
    name: "booking-failed",
    component: () => import("../views/BookingFailed"),
    meta: { requiresAuth: true },
  },
  {
    path: "/payment-successful",
    name: "payment-successful",
    component: () => import("../views/PaymentSuccess"),
    meta: { requiresAuth: true },
  },
  {
    path: "/payment-failed",
    name: "payment-failed",
    component: () => import("../views/PaymentFailed"),
    meta: { requiresAuth: true },
  },
  {
    path: "/event-expired",
    name: "event-expiry",
    component: () => import("../views/EventExpire"),
    meta: { requiresAuth: true },
  },
  {
    path: "/event-booking/:id/pay",
    name: "pay",
    component: () => import("../views/payments/Pay"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/donate/pay",
    name: "donation-pay",
    component: () => import("../views/payments/DonationPay"),
    props: true,
    meta: { requiresAuth: false },
  },
  {
    path: "/product/:id/checkout",
    name: "checkout",
    component: () => import("../views/ProductCheckout"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/checkout",
    name: "cart-checkout",
    component: () => import("../views/CartCheckout"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/product/pay",
    name: "product-pay",
    component: () => import("../views/payments/ProductPay"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/recipe/:id/pay",
    name: "recipe-pay",
    component: () => import("../views/payments/RecipePay"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/hire/chef/:id/pay",
    name: "chef-pay",
    component: () => import("../views/payments/ChefPay"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/hire/interpreter/:id/pay",
    name: "interpreter-pay",
    component: () => import("../views/payments/InterpreterPay"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/accounts",
    component: () => import("../views/accounts"),
    meta: { requiresGuest: true },
    redirect: "/accounts/signin",
    children: [
      {
        path: "signin",
        name: "sign-in",
        component: () => import("../views/accounts/SignIn"),
      },
      {
        path: "signup",
        name: "sign-up",
        component: () => import("../views/accounts/SignUp"),
      },
      {
        path: "password-reset",
        name: "password-reset",
        component: () => import("../views/accounts/PasswordReset"),
      },
      {
        path: "confirm",
        name: "confirm-account",
        component: () => import("../views/accounts/Confirm"),
      },
      {
        path: "change-password/:email",
        props: true,
        name: "change-password",
        component: () => import("../views/accounts/ChangePassword"),
      },
    ],
  },
  {
    path: "/listings/events",
    name: "listings",
    component: () => import("../views/listings/Event"),
    meta: { requiresNoAuth: true },
  },
  {
    path: "/listings/events/:id/details",
    name: "listing-details",
    component: () => import("../views/listings/Details"),
    props: true,
    meta: { requiresNoAuth: true },
  },
  {
    path: "/languages/clubs/:id/details",
    name: "club-details",
    component: () => import("../views/languages/Clubs/Details"),
    props: true,
    meta: { requiresNoAuth: true },
  },
  {
    path: "/languages/interpreter/:id/details",
    name: "interpreter-details",
    component: () => import("../views/languages/Interpreters/Details"),
    props: true,
    meta: { requiresNoAuth: true },
  },
  {
    path: "/languages/events/:id/details",
    name: "language-event-details",
    component: () => import("../views/languages/Courses/Details"),
    props: true,
    meta: { requiresNoAuth: true },
  },
  {
    path: "/recipes",
    name: "recipe-listings",
    component: () => import("../views/recipes/Recipes"),
    meta: { requiresNoAuth: true },
  },
  {
    path: "/recipes/:id/details",
    name: "recipe-details",
    component: () => import("../views/recipes/Details"),
    meta: { requiresNoAuth: true },
  },
  {
    path: "/languages",
    name: "language",
    component: () => import("../views/languages/Languages"),
    meta: { requiresNoAuth: true },
  },
  {
    path: "/languages/events",
    name: "language-events",
    component: () => import("../views/languages/Courses/Events"),
    meta: { requiresNoAuth: true },
  },
  {
    path: "/languages/clubs",
    name: "language-clubs",
    component: () => import("../views/languages/Clubs/Clubs"),
    meta: { requiresNoAuth: true },
  },
  {
    path: "/languages/interpreters",
    name: "language-interpreters",
    component: () => import("../views/languages/Interpreters/Interpreters"),
    meta: { requiresNoAuth: true },
  },
  {
    path: "/listings",
    component: () => import("../views/listings"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "events/create",
        name: "create-listings",
        component: () => import("../views/listings/Create"),
      },
      {
        path: "created",
        name: "created-listings",
        component: () => import("../views/listings/Created"),
      },
      {
        path: ":id/update",
        name: "edit-listing",
        props: true,
        component: () => import("../views/listings/Update"),
      },
      {
        path: "manage",
        name: "manage-listings",
        component: () => import("../views/listings/Manage"),
      },
      {
        path: "bookings",
        name: "event-bookings",
        component: () => import("../views/listings/Bookings"),
      },
    ],
  },
  {
    path: "/recipes",
    component: () => import("../views/recipes"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "create",
        name: "create-recipe-listing",
        component: () => import("../views/recipes/Create"),
      },
      {
        path: "created",
        name: "created-recipe-listings",
        component: () => import("../views/recipes/Created"),
      },
      {
        path: "hires",
        name: "recipe-hirings",
        component: () => import("../views/recipes/Hirings"),
      },
      {
        path: "purchases",
        name: "purchased-recipes",
        component: () => import("../views/recipes/Purchases"),
      },
      {
        path: ":id/edit",
        name: "edit-recipe",
        props: true,
        component: () => import("../views/recipes/Edit"),
      },
    ],
  },
  {
    path: "/languages",
    component: () => import("../views/languages"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "clubs/:id/update",
        name: "update-language-club",
        component: () => import("../views/languages/Clubs/Update"),
        props: true,
      },
      {
        path: "interpreters/:id/update",
        name: "update-interpreter",
        component: () =>
          import("../views/languages/Interpreters/Update"),
        props: true,
      },
      {
        path: "clubs/create",
        name: "create-language-club",
        component: () => import("../views/languages/Clubs/Create"),
      },
      {
        path: "interpreters/create",
        name: "create-interpreter-profile",
        component: () =>
          import("../views/languages/Interpreters/Create"),
      },
      {
        path: "clubs/manage",
        name: "manage-language-clubs",
        component: () => import("../views/languages/Clubs/Manage"),
      },
      {
        path: "clubs/created",
        name: "created-language-clubs",
        component: () => import("../views/languages/Clubs/Created"),
      },
      {
        path: "interpreters/created",
        name: "created-interpreter-profiles",
        component: () =>
          import("../views/languages/Interpreters/Created"),
      },
      {
        path: "events/create",
        name: "create-language-event",
        component: () => import("../views/languages/Courses/Create"),
      },
      {
        path: "events/:id/update",
        name: "update-language-event",
        component: () => import("../views/languages/Courses/Update"),
        props: true,
      },
      {
        path: "events/manage",
        name: "manage-language-events",
        component: () => import("../views/languages/Courses/Manage"),
      },
      {
        path: "interpreters/manage",
        name: "interpreter-hirings",
        component: () => import("../views/languages/Interpreters/Hirings"),
      },
      {
        path: "events/created",
        name: "created-language-events",
        component: () => import("../views/languages/Courses/Created"),
      },
      {
        path: "events/bookings",
        name: "booked-language-events",
        component: () => import("../views/languages/Courses/Bookings"),
      },
      {
        path: "clubs/bookings",
        name: "booked-language-clubs",
        component: () => import("../views/languages/Clubs/Bookings"),
      },
    ],
  },
  {
    path: "/services",
    name: "services",
    component: () => import("../views/products/Services"),
    meta: { requiresNoAuth: true },
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("../views/Cart"),
  },

  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/Profile"),
    meta: { requiresAuth: true },
  },
  {
    path: "/public-profile/:id",
    name: "public-profile",
    props: true,
    component: () => import("../views/PublicProfile"),
    meta: { requiresAuth: true },
  },
  {
    path: "*",
    component: () => import("../views/NotFound"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0, behavior: 'smooth' }
  },
  routes,
  store,
});
router.beforeEach((to, from, next) => {
  if (to.path) {
    // Start the route progress bar.
    NProgress.start();
    NProgress.set(0.1);
  }
  const current_time = Date.now() / 1000;
  const token = localStorage.getItem("culture_token");
  const loginpath = window.location.pathname;
  if (to.matched.some((m) => m.meta.requiresAuth)) {
    if (token === null || token === undefined) {
      localStorage.clear();
      sessionStorage.clear();
      return next({ name: "sign-in", query: { from: loginpath } });
    } else {
      const payload = Vue.$jwt.decode(token);
      if (payload.exp < current_time) {
        localStorage.clear();
        sessionStorage.clear();
        return next({ name: "sign-in", query: { from: loginpath } });
      } else {
        return next();
      }
    }
  } else {
    next();
  }
  if (to.matched.some((m) => m.meta.requiresNoAuth)) {
    if (token === null || token === undefined) {
      localStorage.clear();
      sessionStorage.clear();
      return next();
    } else {
      const payload = Vue.$jwt.decode(token);
      if (payload.exp < current_time) {
        localStorage.clear();
        sessionStorage.clear();
        return next();
      } else {
        return next();
      }
    }
  } else {
    next();
  }
  if (to.matched.some((m) => m.meta.requiresGuest)) {
    if (token === null || token === undefined) {
      localStorage.clear();
      sessionStorage.clear();
      return next();
    } else {
      const payload = Vue.$jwt.decode(token);
      if (payload.exp < current_time) {
        localStorage.clear();
        sessionStorage.clear();
        return next({ path: "/accounts/signin" });
      } else {
        return next({ path: "/" });
      }
    }
  } else {
    next();
  }
});

export default router;
